import React from 'react'
import { shape } from 'prop-types'
import hoistNonReactStatics from 'hoist-non-react-statics'

import { publicRuntimeConfigType } from 'views/utils/propTypes'
import MountPointsClass from 'shared/utils/mountPoints'
import WebviewMountPoints from 'shared/utils/webviewMountpoints'

import withShopAndRuntimeConfig from './withShopAndRuntimeConfig'

const withMountPoints = Component => {
  const ComposedComponent = props => {
    const {
      publicRuntimeConfig: {
        publicConfig: { mountPoints, tenant, language },
        pageProperties: { coreShopEnvironment, isWebview = false }
      }
    } = props

    const mountPointsInstance = isWebview
      ? new WebviewMountPoints({
          mountPoints,
          tenant,
          language,
          coreShopEnvironment
        })
      : new MountPointsClass({
          mountPoints,
          tenant,
          language,
          coreShopEnvironment
        })

    return <Component {...props} mountPoints={mountPointsInstance} />
  }

  ComposedComponent.propTypes = {
    publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired
  }

  // added here because of returning default props in views/containers/esi/SidebarNavigation in catch block
  ComposedComponent.defaultProps = {
    ...Component.defaultProps
  }

  hoistNonReactStatics(ComposedComponent, Component)

  return withShopAndRuntimeConfig(ComposedComponent)
}

export default withMountPoints
